export const SBER_BIC = '044525225';
